var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('Home'),_c('Bio',_vm._b({},'Bio',_vm.bio,false)),_c('Calendar',_vm._b({},'Calendar',_vm.calendar,false)),_c('Highlights',_vm._b({},'Highlights',_vm.highlights,false)),_c('Spotify'),_c('Videos'),_c('Gallery'),_c('SocialMedia'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }